// Select all header-menu elements
const headerMenus = document.querySelectorAll('header-menu');

// Iterate over each header-menu
headerMenus.forEach(headerMenu => {
  // Get the details element inside the current header-menu
  const detailsElement = headerMenu.querySelector('details');
  
  // Add event listener for mouseenter (hover)
  headerMenu.addEventListener('mouseenter', () => {
    // Open the details element
    detailsElement.open = true;
  });

  // Add event listener for mouseleave (hover out)
  headerMenu.addEventListener('mouseleave', () => {
    // Close the details element
    detailsElement.open = false;
  });
});
